import React, { useState } from 'react';
import { BottomSheet, StatusActionButton, AddressSuggest } from '../../../shared/ui';
import { sitesV2Api, CreateSiteV2Request } from '../../../api/sitesV2Api';
import './CreateSiteModal.css';

interface CreateSiteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const CreateSiteModal: React.FC<CreateSiteModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const [name, setName] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [objectAddress, setObjectAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Название объекта обязательно');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const siteData: CreateSiteV2Request = {
        name: name.trim(),
        closed: false,
        customerName: customerName.trim() || undefined,
        objectAddress: objectAddress.trim() || undefined,
      };

      await sitesV2Api.createSite(siteData);
      
      setName('');
      setCustomerName('');
      setObjectAddress('');
      setError(null);
      sitesV2Api.clearSiteCache();
      onSuccess();
      onClose();
    } catch (err: any) {
      console.error('Ошибка создания объекта:', err);
      const errorMessage = err.response?.data?.message || 
                          err.response?.data || 
                          err.message || 
                          'Ошибка создания объекта';
      setError(typeof errorMessage === 'string' ? errorMessage : 'Ошибка создания объекта');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setName('');
      setCustomerName('');
      setObjectAddress('');
      setError(null);
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      title="Создать новый объект"
      size="medium"
      showHandle={true}
      allowSwipeToClose={true}
      allowSwipeToExpand={true}
    >
      <form onSubmit={handleSubmit} className="create-site-form">
        {error && (
          <div className="error-message">
            <i className="ri-error-warning-line"></i>
            <span>{error}</span>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="site-name">Название объекта *</label>
          <input
            id="site-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-input"
            placeholder="Введите название объекта..."
            disabled={loading}
            required
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="site-customer">Заказчик</label>
          <input
            id="site-customer"
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            className="form-input"
            placeholder="Имя заказчика"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="site-address">Адрес объекта</label>
          <AddressSuggest
            id="site-address"
            value={objectAddress}
            onChange={setObjectAddress}
            placeholder="Город, улица, дом, квартира..."
            disabled={loading}
            className="create-site-form-address"
          />
        </div>

        <div className="form-actions">
          <StatusActionButton
            type="button"
            variant="secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Отмена
          </StatusActionButton>
          <StatusActionButton
            type="submit"
            variant="primary"
            disabled={loading || !name.trim()}
            loading={loading}
          >
            Создать
          </StatusActionButton>
        </div>
      </form>
    </BottomSheet>
  );
};

export default CreateSiteModal;

